import { ButtonLink } from 'component-library';
import { Text } from 'deprecated-component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { paths } from '@/routing';

import { NewPasswordPageContent } from '../page-content/PageContent';

export const NewPasswordSuccess: React.FC = () => {
  const { t } = useTranslation();

  return (
    <NewPasswordPageContent headlineText={t('passwordResetSuccess.title')}>
      <Text variant='body1'>{t('passwordResetSuccess.subtitle')}</Text>
      <ButtonLink to={paths.landSteward.projects} size='medium' className='self-end'>
        {t('passwordResetSuccess.continue')}
      </ButtonLink>
    </NewPasswordPageContent>
  );
};
